import React, { FC } from 'react'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { find } from 'lodash/fp'
import { accountsDictSelector } from '../accounts/accountsSelectors'
import { currentUserSelector } from '../auth/authSelectors'
import { IAccount } from '../types/user'
import { managerBranchSelector } from '../manager/managerSelectors'

export default (Component: any) => {
  const Decorator: FC = (props) => {
    const { accountId, branchId } = useParams()
    const currentUser = useSelector(currentUserSelector)
    const isInternal = currentUser.role === 'internal'
    const accounts = useSelector(accountsDictSelector)
    let branch = useSelector(managerBranchSelector)
    let account: IAccount | undefined

    if (branchId && accountId) {
      account = accounts[Number(accountId)]
      if (account) {
        branch = find({ id: +branchId }, account.branches)
      }
    }

    return (
      <Component
        {...props}
        branch={branch}
        account={account}
        isInternal={isInternal}
        user={currentUser}
      />
    )
  }

  return Decorator
}
